export class SortOption {
  constructor(public readonly  value: string,
              public readonly name: string,
              public isSelected: boolean) {
  }
}